// Legacy file required for visyn_scripts, can be ignored.
import { pluginRegistry } from 'visyn_core/plugin';

import reg from './phovea';
import 'visyn_core/phovea_registry';

pluginRegistry.register('stellar', reg);
